import { useEffect, useContext, useState } from "react";
import { BiSolidSun } from "react-icons/bi";
import { RiMoonFill } from "react-icons/ri";
import { ThemeModeContext } from "./Context";
import {
  makeAjax,
  url,
  respStatus,
  prevetHeaderLoad,
} from "../../helpers/global_helper";
import { useDispatch, useSelector } from "react-redux";
import { getPlayerProfileDetail } from "../../store/actions";

const ThemeMode = () => {
  const dispatch = useDispatch();
  const { themeMode, setThemeMode } = useContext(ThemeModeContext);
  const [switchMode, setSwichMode] = useState(themeMode);
  const [changeStatus, setChangeStatus] = useState(false);
  const [colorCode, setColorCode] = useState(null);
  let userToken = window.localStorage.getItem("user_token");

  const changeMode = () => {
    let mode = themeMode;
    if (themeMode == "dark") mode = "light";
    if (themeMode == "light") mode = "dark";

    setThemeMode(mode);
    setChangeStatus(true);
    if (userToken != null && userToken != "") {
      addPlayerTheme(mode);
    }

    localStorage.setItem("mode", mode);
  };
  useEffect(() => {
    let tempMode = themeMode;
    let code = "#2E2B30";
    if (themeMode == "light") {
      tempMode = "light";
      code = "#E5B4FF";
    }
    if (themeMode == "dark") {
      tempMode = "dark";
      code = "#2E2B30";
    }
    setSwichMode(tempMode);
    setColorCode(code);

    document.documentElement.setAttribute("data-dark-mode", themeMode);
    document.body.classList.remove("light", "dark");
    document.body.classList.add(themeMode);
  }, [switchMode, themeMode, changeStatus, colorCode]);



  const addPlayerTheme = (mode) => {
    let palyload = {
      theme_mode: mode,
    };

    makeAjax(url.USER_API.addUpdatePlayerThemeMode, palyload, url.USER_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          //  showMessage(response.messages);
          return;
        }
        dispatch(getPlayerProfileDetail());
      }
    );
  };

  return (
    <div className="toggle-mode">
      <input
        type="checkbox"
        id="toggle-m"
        className={"dark-mode-btn"}
        aria-pressed={switchMode}
        onClick={changeMode}
      />

      <label
        id="switch-m"
        style={{
          background: colorCode,
        }}
        htmlFor="toggle-m"
      >
        {themeMode == "dark" && (
          <>
            <div id="circle-m">
              {<RiMoonFill className={themeMode == "emb"} />}
            </div>
            <div id="text-m">
              <BiSolidSun />
            </div>
            <div id="text-m2">
              <BiSolidSun />
            </div>
          </>
        )}

        {themeMode == "light" && (
          <>
            <div id="circle-m">{<BiSolidSun />}</div>
            <div id="text-m">{<RiMoonFill className="bec" />}</div>
            <div id="text-m2">{<RiMoonFill className="bec" />}</div>
          </>
        )}
      </label>
    </div>
  );
};

export default ThemeMode;
